import { ReduxAction } from '../actions';
import { CourseThemeData } from '../Courses/types';
import { ActionTypes } from './actions';

export const setCourseAppearanceSettingsPreview = (
  settingChanges: CourseThemeData
): ReduxAction => ({
  type: ActionTypes.COURSE_APPEARANCE_SETTINGS_SET_PREVIEW,
  settings: settingChanges,
});

export const clearCourseAppearanceSettingsPreview = (): ReduxAction => ({
  type: ActionTypes.COURSE_APPEARANCE_SETTINGS_CLEAR_PREVIEW,
});
